/** Formatting + utility helpers. */
export const MONTH_NAMES = [
  "Jan", "Feb", "Mar", "Apr", "May", "Jun",
  "Jul", "Aug", "Sep", "Oct", "Nov", "Dec",
];

export const fmtAUD = (v) => {
  if (v == null || v === undefined) return "—";
  return "A$" + Math.round(v).toLocaleString("en-AU");
};

export const fmtPct = (v, withSign = true) => {
  if (v == null) return "—";
  const sign = withSign && v > 0 ? "+" : "";
  return `${sign}${v.toFixed(1)}%`;
};

export const timeAgo = (iso) => {
  if (!iso) return "Never";
  const t = new Date(iso).getTime();
  const diff = (Date.now() - t) / 1000;
  if (diff < 60) return `${Math.floor(diff)}s ago`;
  if (diff < 3600) return `${Math.floor(diff / 60)}m ago`;
  if (diff < 86400) return `${Math.floor(diff / 3600)}h ago`;
  return `${Math.floor(diff / 86400)}d ago`;
};

export const flagFor = (cc) => {
  if (!cc || cc.length !== 2) return "";
  const offset = 0x1f1e6 - 0x41;
  const cu = cc.toUpperCase();
  return String.fromCodePoint(cu.charCodeAt(0) + offset, cu.charCodeAt(1) + offset);
};

export const statusMeta = (s) => {
  switch (s) {
    case "competitive":
      return { label: "SAA Competitive", className: "pill-competitive" };
    case "slightly_undercut":
      return { label: "Slightly Undercut", className: "pill-slight" };
    case "undercut":
      return { label: "Undercut", className: "pill-undercut" };
    default:
      return { label: "No Data", className: "pill-no-data" };
  }
};
